module.exports = __webpack_public_path__ + "static/media/logo-nucleus.2b3ddcce.png";